import styled from "styled-components";
import { MyImage, H2, CentreText, ImageContainer, Small } from "../styles";

// Destructure blogs and title directly from the props
const SecondaryHero = ({ secondaryHeroes }) => {
  return (
    <div>
      {/* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map */}
      {/* Fires callback function for each item, whereby we return a jsx template */}
      {secondaryHeroes.map((secondaryHero) => (
        // When we .map(), each root element we return must have a 'key' property which react uses to keep track of items in the dom
        <TextAndImage key={secondaryHero.id}>
          <CentreText>
            <Small>{secondaryHero.subtitle}</Small>
            <H2>{secondaryHero.heading}</H2>
          </CentreText>

          <GraphicContainer>
            <MyImage
              alt={secondaryHero.imageAlt}
              src={secondaryHero.image}
            ></MyImage>
          </GraphicContainer>
        </TextAndImage>
      ))}
    </div>
  );
};

export default SecondaryHero;

export const TextAndImage = styled.div`
  margin: 120px auto 60px auto;
  position: relative;
  max-width: 1681px;

  @media (max-width: 1681px) {
    margin: 120px 24px 60px 24px;
  }

  @media (max-width: 414px) {
    margin: 100px 20px 20px 20px;
  }
`;

export const GraphicContainer = styled(ImageContainer)`
  height: 70vh;

  @media (max-width: 414px) {
    height: 50vh;
  }
`;
